/** React Query kalitlari bir joyda — invalidatsiya paytida qidirib yurmaslik uchun. */
export const QK = {
  me: ["me"] as const,

  dashboard: {
    all: ["dashboard"] as const,
    summary: (range: unknown) => ["dashboard", "summary", range] as const,
    timeseries: (range: unknown) => ["dashboard", "timeseries", range] as const,
    funnel: (range: unknown) => ["dashboard", "funnel", range] as const,
    breakdown: (range: unknown) => ["dashboard", "breakdown", range] as const,
    top: (range: unknown) => ["dashboard", "top", range] as const,
    /** Davrga bog'liq emas: bitta kalit. */
    queue: ["dashboard", "queue"] as const,
  },

  analytics: (range: unknown) => ["analytics", range] as const,

  /** Promo kodlar (ADR 0018). */
  promo: ["promo"] as const,

  /** Chiqarish soliq profillari (ADR 0019). */
  payouts: (status?: string) => ["payouts", status ?? "all"] as const,

  /** Efirlar (ADR 0023). */
  live: {
    all: ["live"] as const,
    speakers: ["live", "speakers"] as const,
    questions: (id: string) => ["live", "questions", id] as const,
  },

  reference: {
    all: ["reference"] as const,
    industries: ["reference", "industries"] as const,
    regions: ["reference", "regions"] as const,
    districts: (regionCode?: string) => ["reference", "districts", regionCode ?? "all"] as const,
  },

  access: {
    permissions: ["access", "permissions"] as const,
    roles: ["access", "roles"] as const,
    role: (id: string) => ["access", "roles", id] as const,
  },

  users: {
    all: ["users"] as const,
    list: (filter: unknown) => ["users", "list", filter] as const,
    detail: (id: string) => ["users", "detail", id] as const,
    activity: (id: string, query: unknown) => ["users", "activity", id, query] as const,
    sessions: (id: string) => ["users", "sessions", id] as const,
  },

  invitations: {
    all: ["invitations"] as const,
    list: (filter: unknown) => ["invitations", "list", filter] as const,
    detail: (id: string) => ["invitations", "detail", id] as const,
  },

  messages: {
    all: ["messages"] as const,
    list: (filter: unknown) => ["messages", "list", filter] as const,
  },

  reviews: {
    all: ["reviews"] as const,
    list: (filter: unknown) => ["reviews", "list", filter] as const,
  },

  ledger: {
    all: ["ledger"] as const,
    list: (filter: unknown) => ["ledger", "list", filter] as const,
    balanceCheck: ["ledger", "balance-check"] as const,
  },

  payments: (filter: unknown) => ["payments", filter] as const,

  withdrawals: (filter: unknown) => ["withdrawals", filter] as const,

  /** Foydalanuvchining moliyaviy kartochkasi (balans, yig'indi, tarix). */
  userFinance: (id: string) => ["users", "finance", id] as const,

  /**
   * Uchrashuv kartochkasi.
   *
   * `reports.roomEvents` dan ALOHIDA emas — o'sha kalitlar aynan shu
   * ma'lumotni oladi va ikkinchi nusxa bir xil so'rovni ikki marta
   * yuborardi. Bu yerda faqat kartochkaning o'zi bor.
   */
  meetings: {
    detail: (id: string) => ["invitations", "detail", id] as const,
  },

  hostApplications: {
    all: ["host-applications"] as const,
    list: (filter: unknown) => ["host-applications", "list", filter] as const,
    detail: (id: string) => ["host-applications", "detail", id] as const,
  },

  reports: {
    all: ["reports"] as const,
    list: (filter: unknown) => ["reports", "list", filter] as const,
    messages: (id: string, party: string) => ["reports", "messages", id, party] as const,
    meetingChat: (invitationId: string) => ["reports", "chat", invitationId] as const,
    roomEvents: (invitationId: string) => ["reports", "room-events", invitationId] as const,
    roomActivity: (invitationId: string) => ["reports", "room-activity", invitationId] as const,
  },

  audit: {
    all: ["audit"] as const,
    list: (filter: unknown) => ["audit", "list", filter] as const,
  },

  settings: ["settings"] as const,
  settingRules: ["settings", "rules"] as const,
  meetingOptions: ["settings", "meeting-options"] as const,
} as const;
